import React from 'react';
import ReactDOM from 'react-dom/client';

import '@fontsource/source-serif-4/400.css';
import '@fontsource/source-serif-4/500.css';

import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
